import { useState } from "react";
import interceptor from "../lib/interceptor";
import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";

export const usePayment = () => {
  const navigate = useNavigate();
  
  const { mutate: startPayment, isLoading, error } = useMutation({
    mutationFn: async (data) => {
    // console.log(data)
      // اینجا دیتا رو پاس میدی به API
      const response = await interceptor.post(
        "payment/mobile/api/v1/payment/start/",
        data
      );
      return response.data;
    },
    onSuccess: (data) => {
      console.log(data)
      const authority = data?.payment_url?.authority;
      // if (!authority) {
      //   console.log('مشکل');
      //   return;
      // }
      window.open(`https://payment.zarinpal.com/pg/StartPay/${authority}`);
    },
    onError: (err) => {
      console.log(err);
    }
  });

  return { startPayment, isLoading, error };
};